// @core/api/endpoints/workflow/install_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  InstallTemplateRequest,
  PipelineResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Install pipeline template
 * Creates a new pipeline from a template with all nodes and connections pre-configured. The pipeline is created in draft status.
 */
export async function InstallTemplate(
  template_id: string,
  data: InstallTemplateRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/templates/:template_id/install`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
